"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _RuleEditor = _interopRequireDefault(require("../../rule-editor/RuleEditor"));

var _LabelRuleBook = _interopRequireDefault(require("./LabelRuleBook.json"));

var LabelRuleEditor = function LabelRuleEditor(_ref) {
  var rules = _ref.rules,
      setRules = _ref.setRules;
  return /*#__PURE__*/_react.default.createElement(_RuleEditor.default, {
    ruleBook: _LabelRuleBook.default,
    rules: rules,
    setRules: setRules,
    processors: {}
  });
};

var _default = LabelRuleEditor;
exports.default = _default;